/**
 * Product Thumbnail Gallery - Color-based image filtering
 * Handles filtering product images by color variant selection
 */
(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.ProductThumbnailGalleryInitialized) return;
  window.ProductThumbnailGalleryInitialized = true;
  
  document.addEventListener('DOMContentLoaded', function () {
    try {
      var colorRadios = document.querySelectorAll('input[name="Farbe"]');
      if (!colorRadios || colorRadios.length === 0) {
        return;
      }
      
      // State
      var currentVisibleSlides = [];
      var currentVisibleIndex = 0;
      var globalSwiper = null;
      var isAnimating = false;
      var filteredLightbox = null;
      
      // Touch tracking
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;
      var minSwipeDistance = 50;
    
    function isModelPhoto(mediaItem) {
      var src = mediaItem.getAttribute('data-src') || '';
      return src.toLowerCase().indexOf('model_p_') !== -1 || 
             src.toLowerCase().indexOf('model-p-') !== -1 ||
             src.toLowerCase().indexOf('/model_') !== -1;
    }
    
    function updatePaginationDisplay() {
      if (!globalSwiper || !globalSwiper.pagination || !globalSwiper.pagination.el) return;
      if (currentVisibleSlides.length === 0) return;
      
      var totalVisible = currentVisibleSlides.length;
      var displayIndex = currentVisibleIndex + 1;
      globalSwiper.pagination.el.textContent = displayIndex + ' / ' + totalVisible;
    }
    
    function navigateToSlide(visibleIndex, instant) {
      if (isAnimating) return;
      if (!globalSwiper || visibleIndex < 0 || visibleIndex >= currentVisibleSlides.length) return;
      
      isAnimating = true;
      currentVisibleIndex = visibleIndex;
      
      // After filtering, Swiper's navigable index space is the filtered visible
      // sequence (snapGrid length), not original DOM indices. Use visibleIndex directly.
      globalSwiper.slideTo(visibleIndex, instant ? 0 : 300, false);
      
      updatePaginationDisplay();
      
      setTimeout(function() {
        isAnimating = false;
      }, instant ? 50 : 350);
    }
    
    function goToNext() {
      if (currentVisibleSlides.length === 0) return;
      var nextIndex = (currentVisibleIndex + 1) % currentVisibleSlides.length;
      navigateToSlide(nextIndex);
    }
    
    function goToPrev() {
      if (currentVisibleSlides.length === 0) return;
      var prevIndex = (currentVisibleIndex - 1 + currentVisibleSlides.length) % currentVisibleSlides.length;
      navigateToSlide(prevIndex);
    }
    
    function handleTouchStart(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }
    
    function handleTouchMove(e) {
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    }
    
    function handleTouchEnd(e) {
      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;
      
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX < 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
      
      touchStartX = 0;
      touchStartY = 0;
      touchEndX = 0;
      touchEndY = 0;
    }
    
    function setupTouchHandlers(mediaGallery) {
      var galleryViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
      if (!galleryViewer) return;
      
      galleryViewer.removeEventListener('touchstart', handleTouchStart);
      galleryViewer.removeEventListener('touchmove', handleTouchMove);
      galleryViewer.removeEventListener('touchend', handleTouchEnd);
      
      galleryViewer.addEventListener('touchstart', handleTouchStart, { passive: true });
      galleryViewer.addEventListener('touchmove', handleTouchMove, { passive: true });
      galleryViewer.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
    
    function setupButtonHandlers(mediaGallery) {
      var nextBtn = mediaGallery.querySelector('.swiper-button-next');
      var prevBtn = mediaGallery.querySelector('.swiper-button-prev');
      
      if (nextBtn) {
        var newNextBtn = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
        newNextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToNext();
        });
      }
      
      if (prevBtn) {
        var newPrevBtn = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
        newPrevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToPrev();
        });
      }
    }
    
    function initFilteredLightbox() {
      if (filteredLightbox) {
        filteredLightbox.destroy();
        filteredLightbox = null;
      }
      
      if (!window.FoxTheme || !window.FoxTheme.PhotoSwipeLightbox) {
        return;
      }
      
      var dataSource = [];
      currentVisibleSlides.forEach(function(media, index) {
        var mediaType = media.getAttribute('data-media-type');
        
        if (mediaType === 'image') {
          dataSource.push({
            id: index,
            src: media.getAttribute('data-src'),
            width: parseInt(media.getAttribute('data-pswp-width')) || 1946,
            height: parseInt(media.getAttribute('data-pswp-height')) || 1946,
            mediaType: mediaType,
          });
        }
      });
      
      if (dataSource.length === 0) return;
      
      filteredLightbox = new window.FoxTheme.PhotoSwipeLightbox({
        dataSource: dataSource,
        pswpModule: window.FoxTheme.PhotoSwipe,
        bgOpacity: 1,
        arrowPrev: false,
        arrowNext: false,
        zoom: false,
        close: false,
        counter: false,
        preloader: false,
      });
      
      filteredLightbox.on('uiRegister', function() {
        if (dataSource.length > 1) {
          filteredLightbox.pswp.ui.registerElement({
            name: 'next',
            ariaLabel: 'Next slide',
            order: 3,
            isButton: true,
            html: '<svg class="pswp-icon-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg>',
            onClick: function() {
              filteredLightbox.pswp.next();
            },
          });
          filteredLightbox.pswp.ui.registerElement({
            name: 'prev',
            ariaLabel: 'Previous slide',
            order: 1,
            isButton: true,
            html: '<svg class="pswp-icon-prev" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
            onClick: function() {
              filteredLightbox.pswp.prev();
            },
          });
        }
        filteredLightbox.pswp.ui.registerElement({
          name: 'close-zoom',
          ariaLabel: 'Close zoom image',
          order: 2,
          isButton: true,
          html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
          onClick: function() {
            filteredLightbox.pswp.close();
          },
        });
      });
      
      filteredLightbox.on('change', function() {
        var currIndex = filteredLightbox.pswp.currIndex;
        if (currIndex !== currentVisibleIndex) {
          navigateToSlide(currIndex, true);
        }
      });
      
      filteredLightbox.init();
    }
    
    function setupLightboxTriggers(mediaGallery) {
      var zoomButtons = mediaGallery.querySelectorAll('.js-photoswipe--zoom');
      zoomButtons.forEach(function(btn) {
        var newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (!filteredLightbox) return;
          
          var mediaItem = newBtn.closest('.product__media-item');
          if (!mediaItem) return;
          
          var mediaId = mediaItem.getAttribute('data-media-id');
          var visibleIndex = 0;
          
          for (var i = 0; i < currentVisibleSlides.length; i++) {
            if (currentVisibleSlides[i].getAttribute('data-media-id') === mediaId) {
              visibleIndex = i;
              break;
            }
          }
          
          filteredLightbox.loadAndOpen(visibleIndex);
        });
      });
    }
    
    function filterAndShowImages() {
      var selectedRadio = document.querySelector('input[name="Farbe"]:checked');
      if (!selectedRadio) return;
      
      var rawColorCode = selectedRadio.getAttribute('data-color-code') || '';
      var selectedColorCode = rawColorCode.replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase();
      
      if (!selectedColorCode) return;
      
      var mediaItems = document.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');
      var visibleItems = [];
      var modelImage = null;
      var modelImageIndex = -1;
      
      mediaItems.forEach(function(mediaItem) {
        var mediaColorCode = (mediaItem.getAttribute('data-color') || '').toLowerCase();
        
        mediaItem.classList.remove('first-visible-slide');
        mediaItem.style.width = '';
        mediaItem.style.order = '';
        
        if (mediaColorCode === selectedColorCode) {
          mediaItem.style.display = '';
          
          if (isModelPhoto(mediaItem) && !modelImage) {
            modelImage = mediaItem;
            modelImageIndex = visibleItems.length;
          }
          
          visibleItems.push(mediaItem);
        } else {
          mediaItem.style.display = 'none';
        }
      });
      
      var isDesktopGridView = window.innerWidth >= 768;
      
      if (visibleItems.length > 0) {
        if (modelImage && modelImageIndex > 0) {
          visibleItems.splice(modelImageIndex, 1);
          visibleItems.unshift(modelImage);
          modelImageIndex = 0;
        }
        
        visibleItems.forEach(function(item, index) {
          if (isDesktopGridView) {
            item.style.order = index;
            
            if (index === 0) {
              item.classList.add('first-visible-slide');
              item.style.width = '100%';
            } else {
              item.style.width = '50%';
            }
          } else {
            item.style.width = '';
            item.style.order = index;
          }
        });
      }
      
      mediaItems.forEach(function(mediaItem) {
        if (mediaItem.style.display === 'none') {
          mediaItem.style.order = 9999;
        }
      });
      
      var duplicateSlides = document.querySelectorAll('.product__media-item.swiper-slide-duplicate');
      duplicateSlides.forEach(function(dupSlide) {
        var dupMediaId = dupSlide.getAttribute('data-media-id');
        var originalSlide = document.querySelector('.product__media-item:not(.swiper-slide-duplicate)[data-media-id="' + dupMediaId + '"]');
        if (originalSlide) {
          dupSlide.style.display = originalSlide.style.display;
          dupSlide.style.order = originalSlide.style.order;
          dupSlide.style.width = originalSlide.style.width;
        }
      });
      
      currentVisibleSlides = visibleItems;
      currentVisibleIndex = 0;
      
      function applySwiperLogic() {
        var mediaGallery = document.querySelector('media-gallery');
        
        if (window.innerWidth >= 768) {
          initFilteredLightbox();
          if (mediaGallery) setupLightboxTriggers(mediaGallery);
          return;
        }
        
        if (!mediaGallery || !mediaGallery.sliderInstance || !mediaGallery.sliderInstance.slider) {
          setTimeout(applySwiperLogic, 100);
          return;
        }
        
        globalSwiper = mediaGallery.sliderInstance.slider;
        
        globalSwiper.allowTouchMove = false;
        globalSwiper.allowSlideNext = true;
        globalSwiper.allowSlidePrev = true;
        
        globalSwiper.update();
        
        setupTouchHandlers(mediaGallery);
        setupButtonHandlers(mediaGallery);
        
        initFilteredLightbox();
        setupLightboxTriggers(mediaGallery);
        
        navigateToSlide(currentVisibleIndex, true);
      }
      
      applySwiperLogic();
    }
    
    colorRadios.forEach(function(radio) {
      radio.addEventListener('change', filterAndShowImages);
    });
    
    filterAndShowImages();
    
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (globalSwiper) {
          globalSwiper.update();
          navigateToSlide(currentVisibleIndex, true);
        }
      }, 150);
    });
    
    } catch (e) {
      // Fail silently
    }
  });
})();
